export default "__VITE_ASSET__QYqHDdN9__"